import { emptyHokm, type HokmLocal } from "../hokm/state";
import { unitOf, type ShelemLocal } from "./state";

/**
 * میزِ شلم از چشمِ صحنه، همان میزِ حکم است.
 *
 * چهار صندلی، دستِ پایین، خالِ وسط، مدالِ حکم، تاجِ حاکم و کپه‌ی دست‌های برده —
 * هر کدامشان در HokmScene ساخته و آزموده شده. آنچه شلم *بیشتر* دارد مزایده و
 * واگذاری است، و آن دو صفحه‌ی ری‌اکت‌اند و نه صحنه؛ هیچ‌کدام کارتی روی میز
 * جابه‌جا نمی‌کنند.
 *
 * پس به‌جای پانصد خط صحنه‌ی دوباره، این‌جا وضعیتِ شلم را به شکلی که صحنه
 * می‌شناسد ترجمه می‌کنیم. تایپ‌اسکریپت نگهبانش است: اگر روزی HokmScene فیلدِ
 * تازه‌ای از HokmLocal بخواهد، همین‌جا کامپایل می‌شکند و نه سرِ اجرا.
 *
 * یک نگاشتِ معنایی دارد که ارزشِ گفتن دارد: **حاکمِ شلم همان حاکمِ حکم است** —
 * کسی که حکم می‌خواند و خالِ اول را شروع می‌کند. پس تاجِ صحنه روی همان
 * می‌نشیند و لازم نیست نشانِ تازه‌ای ساخته شود.
 */
export function asHokmView(st: ShelemLocal): HokmLocal {
  const v = emptyHokm(st.n);
  v.me = st.me;
  v.myHand = st.myHand;
  v.counts = st.counts;
  v.trick = st.trick;
  v.trickLeader = st.trickLeader;
  v.ledSuit = st.ledSuit;
  v.turn = st.turn;
  // ‎-۱ تا پایانِ مزایده؛ صحنه تاج را روی صندلیِ منفی نمی‌گذارد.
  v.hakem = st.declarer;
  v.trumpChosen = st.trumpChosen;
  v.trump = st.trump;
  v.awaitingTrump = st.declarer >= 0 && !st.trumpChosen;
  v.seatUnit = Array.from({ length: st.n }, (_, l) => unitOf(l));
  v.units = 2;
  v.teams = true;
  v.myUnit = st.myUnit;
  v.tricksWon = st.tricksWon;
  v.score = st.score;
  // شلم «اولین که هفت دست ببرد» ندارد؛ امتیازی است. صحنه این دو را فقط برای
  // نوارِ بالا می‌خواند و ما خودمان نوارِ شلم را می‌کشیم.
  v.tricksToWin = 0;
  v.matchTarget = st.targetScore;
  v.handOver = st.handOver;
  v.matchOver = st.matchOver;
  v.names = st.names;
  v.bots = st.bots;
  v.avatars = st.avatars;
  v.connected = st.connected;
  v.subscribers = st.subscribers;
  v.places = st.places;
  v.carpet = st.carpet;
  v.myTurn = st.myTurn;
  v.awaitingTrumpFromMe = st.awaitingTrumpFromMe;
  v.turnRemaining = st.turnRemaining;
  v.watching = st.watching;
  return v;
}
